<script context="module">
    import { number } from 'yup';

    export const getValidationSchema = () => ({
        times_since_new_months: number().min(0).nullable(),
        times_since_new_hours: number().min(0).nullable(),
        times_since_new_landings: number().min(0).nullable(),
        times_since_new_cycles: number().min(0).nullable(),

        times_since_overhaul_months: number().min(0).nullable(),
        times_since_overhaul_hours: number().min(0).nullable(),
        times_since_overhaul_landings: number().min(0).nullable(),
        times_since_overhaul_cycles: number().min(0).nullable(),

        times_since_repair_months: number().min(0).nullable(),
        times_since_repair_hours: number().min(0).nullable(),
        times_since_repair_landings: number().min(0).nullable(),
        times_since_repair_cycles: number().min(0).nullable(),
    });
</script>

<script>
    import { createEventDispatcher } from 'svelte';

    import Number from './Number.svelte';
    import {
        isCyclesAvailable as getIsCyclesAvailable,
        isLandingsAvailable as getIsLandingsAvailable,
    } from 'src/core/state';

    export let equipmentType;

    export let newMonths;
    export let newHours;
    export let newLandings;
    export let newCycles;

    export let overhaulMonths;
    export let overhaulHours;
    export let overhaulLandings;
    export let overhaulCycles;

    export let repairMonths;
    export let repairHours;
    export let repairLandings;
    export let repairCycles;

    const dispatch = createEventDispatcher();

    const createChangeEvent = (fieldName) => value => dispatch('change', {
        fieldName,
        value,
    });

    $: isLandingsAvailable = getIsLandingsAvailable(equipmentType);
    $: isCyclesAvailable = getIsCyclesAvailable(equipmentType);
</script>

<div class="times-since">
    <div></div>
    <div>New</div>
    <div>Overhaul</div>
    <div>Repair</div>

    <div>Months</div>
    <div>
        <Number
            min="0"
            bind:value={newMonths}
            on:change={createChangeEvent('times_since_new_months')}
        />
    </div>
    <div>
        <Number
            min="0"
            bind:value={overhaulMonths}
            on:change={createChangeEvent('times_since_overhaul_months')}
        />
    </div>
    <div>
        <Number
            min="0"
            bind:value={repairMonths}
            on:change={createChangeEvent('times_since_repair_months')}
        />
    </div>

    <div>Hours</div>
    <div>
        <Number
            min="0"
            bind:value={newHours}
            on:change={createChangeEvent('times_since_new_hours')}
        />
    </div>
    <div>
        <Number
            min="0"
            bind:value={overhaulHours}
            on:change={createChangeEvent('times_since_overhaul_hours')}
        />
    </div>
    <div>
        <Number
            min="0"
            bind:value={repairHours}
            on:change={createChangeEvent('times_since_repair_hours')}
        />
    </div>

    {#if isLandingsAvailable}
        <div>Landings</div>
        <div>
            <Number
                min="0"
                bind:value={newLandings}
                on:change={createChangeEvent('times_since_new_landings')}
            />
        </div>
        <div>
            <Number
                min="0"
                bind:value={overhaulLandings}
                on:change={createChangeEvent('times_since_overhaul_landings')}
            />
        </div>
        <div>
            <Number
                min="0"
                bind:value={repairLandings}
                on:change={createChangeEvent('times_since_repair_landings')}
            />
        </div>
    {/if}

    {#if isCyclesAvailable}
        <div>Cycles</div>
        <div>
            <Number
                min="0"
                bind:value={newCycles}
                on:change={createChangeEvent('times_since_new_cycles')}
            />
        </div>
        <div>
            <Number
                min="0"
                bind:value={overhaulCycles}
                on:change={createChangeEvent('times_since_overhaul_cycles')}
            />
        </div>
        <div>
            <Number
                min="0"
                bind:value={repairCycles}
                on:change={createChangeEvent('times_since_repair_cycles')}
            />
        </div>
    {/if}
</div>

<style>
    .times-since {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(5, auto);
        gap: 5px 10px;
    }

    .times-since :global(.number) {
        margin: 0;
    }
</style>
